import React from 'react';
import LayoutContent from 'common/oldJavascripts/components/Base/Layout/LayoutContent';
import OffersTable from 'onboarding/oldJavascripts/components/Pages/Offer/Offers/Table';

const MobileOfferList = () => (
  <LayoutContent>
    <OffersTable type="sent" params={{ status: 'new' }} />
    <OffersTable type="submitted" params={{ status: 'submitted' }} />
    <OffersTable type="approved" params={{ status: 'approved' }} />
    <OffersTable type="employeeRejected" params={{ status: 'rejected' }} />
    <OffersTable type="optedOut" params={{ status: 'opted-out' }} />
  </LayoutContent>
);

export default MobileOfferList;
